export class FilterRequest {
  cedula: String;
  facultad: number;
  programa: number;
  tipo: String;
  estado: String;
  excluirEstado: boolean;
  excluirTipo: boolean;
  tipoResultado: number;
  evaluador: String;
}


